export default {
    records: [
        {
            "name": "The Beatles",
            "data": "289,500,000"
        },
        {
            "name": "Elvis Presley",
            "data": "230,600,000"
        },
        {
            "name": "Michael Jackson",
            "data": "258,900,000"
        },
        {
            "name": "Elton John",
            "data": "206,400,000"
        },
        {
            "name": "Madonna",
            "data": "181,200,000"
        },
        {
            "name": "Led Zeppelin",
            "data": "142,200,000"
        },
        {
            "name": "Rihanna",
            "data": "334,100,000"
        },
        {
            "name": "Pink Floyd",
            "data": "123,400,000"
        },
        {
            "name": "Eminem",
            "data": "323,200,000"
        },
        {
            "name": "Mariah Carey",
            "data": "196,100,000"
        },
        {
            "name": "Taylor Swift",
            "data": "237,970,000"
        },
        {
            "name": "Queen",
            "data": "171,300,000"
        },
        {
            "name": "Whitney Houston",
            "data": "155,100,000"
        },
        {
            "name": "Eagles",
            "data": "152,000,000"
        },
        {
            "name": "Celine Dion",
            "data": "137,000,000"
        },
        {
            "name": "AC/DC",
            "data": "129,100,000"
        },
        {
            "name": "The Rolling Stones",
            "data": "102,400,000"
        },
        {
            "name": "Drake",
            "data": "397,200,000"
        },
        {
            "name": "Garth Brooks",
            "data": "165,300,000"
        },
        {
            "name": "Kanye West",
            "data": "247,900,000"
        },
        {
            "name": "Justin Bieber",
            "data": "264,800,000"
        },
        {
            "name": "Ed Sheeran",
            "data": "243,500,000"
        },
        {
            "name": "Billy Joel",
            "data": "134,300,000"
        },
        {
            "name": "Bruce Springsteen",
            "data": "126,700,000"
        },
        {
            "name": "U2",
            "data": "114,600,000"
        },
        {
            "name": "Aerosmith",
            "data": "104,600,000"
        },
        {
            "name": "Barbra Streisand",
            "data": "98,300,000"
        },
        {
            "name": "Phil Collins",
            "data": "96,800,000"
        },
        {
            "name": "ABBA",
            "data": "68,700,000"
        },
        {
            "name": "Katy Perry",
            "data": "172,300,000"
        },
        {
            "name": "Chris Brown",
            "data": "197,800,000"
        },
        {
            "name": "Bruno Mars",
            "data": "198,900,000"
        },
        {
            "name": "Jay-Z",
            "data": "135,300,000"
        },
        {
            "name": "Metallica",
            "data": "105,300,000"
        },
        {
            "name": "Lady Gaga",
            "data": "157,200,000"
        },
        {
            "name": "Lil Wayne",
            "data": "164,700,000"
        },
        {
            "name": "Maroon 5",
            "data": "142,500,000"
        },
        {
            "name": "Adele",
            "data": "131,600,000"
        },
        {
            "name": "Beyoncé",
            "data": "112,100,000"
        },
        {
            "name": "Fleetwood Mac",
            "data": "93,700,000"
        },
        {
            "name": "Rod Stewart",
            "data": "84,900,000"
        },
        {
            "name": "Bee Gees",
            "data": "74,500,000"
        },
        {
            "name": "Nicki Minaj",
            "data": "154,400,000"
        },
        {
            "name": "Coldplay",
            "data": "105,100,000"
        },
        {
            "name": "Linkin Park",
            "data": "101,800,000"
        },
        {
            "name": "Red Hot Chili Peppers",
            "data": "99,500,000"
        },
        {
            "name": "Pink",
            "data": "88,900,000"
        },
        {
            "name": "Britney Spears",
            "data": "88,500,000"
        },
        {
            "name": "Bon Jovi",
            "data": "88,400,000"
        },
        {
            "name": "B'z",
            "data": "86,200,000"
        }
    ],
    question: "Which artist has sold more records all-time?"
}